import React, { FC } from 'react'
import { motion } from 'framer-motion'

interface ReliabilityHeathCareStepsProps {
    healthCareData: any
}

// Animation variants
const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.2
        }
    }
}

const itemVariants = {
    hidden: { opacity: 0.6, y: 10 },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.5
        }
    }
}

const ReliabilityHeathCareSteps: FC<ReliabilityHeathCareStepsProps> = ({ healthCareData }) => {
    // Helper function to handle dynamic color classes safely
    const getColorClass = (type: string, color: string) => {
        if (type === 'bg') {
            switch (color) {
                case 'yellow': return 'group-hover:bg-yellow';
                case 'green': return 'group-hover:orange-bg';
                case 'purple': return 'group-hover:bg-purple';
                default: return 'group-hover:bg-yellow';
            }
        } else if (type === 'text') {
            switch (color) {
                case 'yellow': return 'group-hover:text-yellow';
                case 'green': return 'group-hover:text-second';
                case 'purple': return 'group-hover:text-purple';
                default: return 'group-hover:text-yellow';
            }
        }
        return '';
    };

    return (
        <div>
            <motion.div
                className='grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-12 p-4 md:p-8 lg:p-16 px-4 md:px-8 lg:px-36 bg-blackDark'
                variants={containerVariants}
                initial="hidden"
                animate="visible"
            >
                {healthCareData.ReliabilityHealthcareData.map((reliable: any, index: number) => {
                    return (
                        <motion.div
                            key={index}
                            className="bg-darkGreyPrimary rounded-2xl md:rounded-3xl"
                            variants={itemVariants}
                            whileHover={{ scale: 1.03 }}
                            transition={{ type: "spring", stiffness: 300 }}
                        >
                            <div className={`group hover:bg-${reliable.color} hover:rounded-2xl md:hover:rounded-3xl hover:pt-[1px] h-full`}>
                                <div className='h-full bg-darkGreyPrimary flex flex-col items-start justify-center p-6 md:p-8 relative overflow-hidden gap-2 rounded-2xl md:rounded-3xl'>
                                    <motion.div
                                        className={`w-12 h-12 md:w-14 md:h-14 rounded-full bg-blackDark text-white flex items-center justify-center font-bold text-xl md:text-2xl group-hover:text-black ${getColorClass('bg', reliable.color)}`}
                                        whileHover={{ rotate: 5 }}
                                    >
                                        {reliable.key}.
                                    </motion.div>
                                    <div className={`text-lg md:text-xl text-start font-semibold mb-1 text-white ${getColorClass('text', reliable.color)}`}>
                                        {reliable.title}
                                    </div>
                                    <motion.div
                                        className='text-lightGrey text-xs md:text-sm'
                                        initial={{ opacity: 0.8 }}
                                        whileHover={{ opacity: 1 }}
                                    >
                                        {reliable.subtitle}
                                    </motion.div>
                                    <motion.div
                                        className={`w-0 h-1 mt-auto absolute bottom-0 left-0`}
                                        transition={{ duration: 0.3 }}
                                    />
                                </div>
                            </div>
                        </motion.div>
                    )
                })}
            </motion.div>
        </div>
    )
}

export default ReliabilityHeathCareSteps
